import { fetchJson, setAuthToken } from './http'

export function makeAuthApi({ token: token }) {
  async function login(publicKey, message, signature) {
    const json = await fetchJson('/api/login', {
      method: 'POST',
      body: JSON.stringify({ public_key: publicKey, message, signature }),
    })
    token.value = json.token
    setAuthToken(json.token)
    return true
  }

  async function check() {
    try {
      const json = await fetchJson('/api/check', { method: 'GET' })
      token.value = json.token
      setAuthToken(json.token)
      return true
    } catch (_) {
      token.value = null
      setAuthToken('')
      return false
    }
  }

  async function logout() {
    try {
      await fetchJson('/api/logout', { method: 'POST' })
    } finally {
      token.value = null
      setAuthToken('')
    }
  }

  return { login, check, logout }
}
